import { render, staticRenderFns } from "./apreval.vue?vue&type=template&id=4840b79e&scoped=true"
import script from "./apreval.vue?vue&type=script&lang=js"
export * from "./apreval.vue?vue&type=script&lang=js"
import style0 from "./apreval.vue?vue&type=style&index=0&id=4840b79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840b79e",
  null
  
)

export default component.exports